import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-additional-work-request-info-modal',
  templateUrl: './additional-work-request-info.component.html',
  styleUrls: ['../modal.component.scss'],
})
export class AdditionalWorkRequestInfoComponent {
  @Input() prevWorkRequestData: any;
  @Output() readonly responseChanged = new EventEmitter();

  isMaterialsSectionOpen: boolean;
  isOperationsSectionOpen: boolean;

  emitFalse(): void {
    this.responseChanged.emit(false);
  }

  onToggleMaterialsSection(): void {
    this.isMaterialsSectionOpen = !this.isMaterialsSectionOpen;
  }

  onToggleOperationsSection(): void {
    this.isOperationsSectionOpen = !this.isOperationsSectionOpen;
  }
}
